import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CharterBuyflowVesselsComponent } from './charter-buyflow-vessels.component';
import { CharterBuyflowVesselsResolve } from './charter-buyflow-vessels.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: CharterBuyflowVesselsComponent,
        resolve: {
          buyflowData: CharterBuyflowVesselsResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class CharterBuyflowVesselsRoutingModule {}
